const categoryMap = {
  // Auto categories
  cars: {
    title: 'Cars',
    label: {
      singular: 'car',
      plural: 'cars'
    }
  },
  // Home categories
  bathrooms: {
    title: 'Bathrooms',
    label: {
      singular: 'bathroom',
      plural: 'bathrooms'
    }
  },
  kitchens: {
    title: 'Kitchens',
    label: {
      singular: 'kitchen',
      plural: 'kitchens'
    }
  },
  frontDoors: {
    title: 'Front doors',
    label: {
      singular: 'front door',
      plural: 'front doors'
    }
  },
  homeExteriors: {
    title: 'Home exterior',
    label: {
      singular: 'exterior',
      plural: 'exteriors'
    }
  },
  fireplaces: {
    title: 'Fireplaces',
    label: {
      singular: 'fireplace',
      plural: 'fireplaces'
    }
  },
  electricalBoxes: {
    title: 'Electrical boxes',
    label: {
      singular: 'electrical box',
      plural: 'electrical boxes'
    }
  },
  waterline: {
    title: 'Water supply lines',
    label: {
      singular: 'water line',
      plural: 'water lines'
    }
  },
  trampolines: {
    title: 'Trampolines',
    label: {
      singular: 'trampoline',
      plural: 'trampolines'
    }
  },
  pets: {
    title: 'Pets',
    label: {
      singular: 'pet',
      plural: 'pets'
    }
  },
  swimmingPools: {
    title: 'Swimming pools',
    label: {
      singular: 'swimming pool',
      plural: 'swimming pools'
    }
  },
  // Umbrella categories
  watercrafts: {
    title: 'Watercrafts',
    label: {
      singular: 'watercraft',
      plural: 'watercrafts'
    }
  },
  recreationalVehicle: {
    title: 'Recreational vehicles',
    label: {
      singular: 'recreational vehicle',
      plural: 'recreational vehicles'
    }
  },
  atv: {
    title: 'ATVs',
    label: {
      singular: 'ATV',
      plural: 'ATVs'
    }
  },
  motorcycle: {
    title: 'Motorcycles',
    label: {
      singular: 'motorcycle',
      plural: 'motorcycles'
    }
  },
  largeWatercraft: {
    title: 'Large watercraft',
    label: {
      singular: 'large watercraft',
      plural: 'large watercraft'
    }
  },
  personalWatercraft: {
    title: 'Small watercraft',
    label: {
      singular: 'small watercraft',
      plural: 'small watercraft'
    }
  },
  // SPP categories
  spp: {
    title: 'Scheduled personal property (SPP) items',
    label: {
      singular: 'SPP item',
      plural: 'SPP items'
    }
  }
};

export default categoryMap;
